import { createSelector } from 'reselect'
import { IStore } from '../../reducers/index'

const skinSelector = (state: IStore) => state.app.skin

export default createSelector(skinSelector, (skin) => {
	return skin
})
